<template>
  <div class="glass h-full transition duration-700 transform rounded-lg hover:shadow-sm hover:scale-105" style="overflow: hidden">
    <!-- 展示卡片 -->
    <!-- <el-skeleton style="width: 240px" :loading="loading" animated>

        </el-skeleton> -->

    <div @click="enterDetail" class="flex flex-col items-start w-full cursor-pointer">
      <!-- 课程图片 -->
      <el-image class="w-full transition duration-700 transform rounded-t-lg h-44 lg:h-40 hover:scale-110" :src="objData.course_cover_url" fit="cover" lazy loading="lazy">
        <template #error>
          <div class="image-slot">
            <el-icon><icon-picture /></el-icon>
          </div>
        </template>
      </el-image>

      <div class="w-full">
        <!-- 课程名称(限制最高高度)-->
        <div class="lg:h-20 h-14">
          <span class="p-2 text-xs font-bold lg:text-sm text-wrap line-clamp-2">
            {{ objData.course_name }}
          </span>
          <!-- 课程介绍 -->
          <span class="pl-2 pr-2 text-xs text-wrap text-slate-500 line-clamp-2">
            {{ objData.course_introduce }}
          </span>
        </div>

        <!-- 底部标签 -->
        <div class="flex flex-row items-center w-full p-2 pb-2">
          <div class="flex flex-col items-center space-x-2 md:flex-row md:text-xs">
            <TagVue class="lg:scale-100 md:scale-75">{{ objData.rank_name }}</TagVue>
            <!-- <TagVue v-if="isTrue" class="text-white lg:scale-100 md:scale-75"
                            :bg-color="checkBgColor(objData.tag_name)">{{ objData.tag_name }}
                           
                        </TagVue> -->
            <el-tag v-if="isTrue" effect="light" class="lg:scale-100 md:scale-75" :type="`${checkBgColor(objData.tag_name)}`" size="small">{{ objData.tag_name }}</el-tag>
          </div>

          <div class="flex justify-end ml-auto space-x-2 text-xs tracking-wide text-gray-400 lg:scale-100 md:scale-75">
            <!-- 课程课时 -->
            <span>{{ objData.times ?? 0 }}课时</span>
            <!-- 观看次数 -->
            <span>{{ objData.views ?? 0 }}次观看</span>
            <!-- <el-button class="lg:scale-100 md:scale-75" type="primary" size="small" >开始学习</el-button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Picture as IconPicture } from '@element-plus/icons-vue'
import TagVue from '~/components/TagVue.vue'
import { userLogin } from '~/stores/userLogin'

// //监视加载状态中的骨架图
// watch(()=> props.loading, (newValue) => {
//     props.loading = newValue
// })

const props = defineProps({
  //传过来的对象
  objData: {
    type: Object,
    required: true,
  },
  isTrue: {
    type: Boolean,
    default: true,
  },
})

console.log('props is ', props)

//进入到开始学习界面并且传递必要的参数
const router = useRouter()
const loginStore = userLogin()
const enterDetail = () => {
  //路由传入对应的视频 ID 进入到对应的学习课程中
  if (loginStore.isLogin) {
    router.push({ path: '/classDetail', query: { id: props.objData.id, name: props.objData.course_name } })
  } else {
    ElMessage({
      message: '登录信息过期，请重新登录',
      type: 'error',
    })
  }
}

// 判断课程类型返回颜色
const checkBgColor = (rank: string): string => {
  const cleanedRank = rank.trim().replace(/\s+/g, '') // 去除两端空格并将中间连续空格替换为单个空格
  // 包含'编程'但不包含'直播'
  if (cleanedRank.includes('编程') && !cleanedRank.includes('直播')) {
    return 'success'
  }
  // 包含'编程'且包含'直播'
  if (cleanedRank.includes('编程') && cleanedRank.includes('直播')) {
    return 'warning'
  }
  // UI设置
  if (cleanedRank.includes('UI')) {
    return 'info'
  }
  // 人人能创造
  if (cleanedRank.includes('人人能创造')) {
    return 'danger'
  }

  return 'primary'
}
</script>
